angular.module('content_delivery_system').directive("contentDeliveryDirective", [
	function () {
		return {
			restrict: 'E',
			replace: true,
			templateUrl: '/static/assets/khapps/content_delivery_system/ContentDeliveryMessageBox.html'
		}
	}]);